import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=5a1449af&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=5a1449af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1449af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1449af')) {
      api.createRecord('5a1449af', component.options)
    } else {
      api.reload('5a1449af', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=5a1449af&scoped=true&", function () {
      api.rerender('5a1449af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUh9a3P9PJMR/JS/comp/PopupDialog.vue"
export default component.exports